// The Code editor and the Theme editor open in their own browser tabs (owner, 2026-10-26/27: "like
// Visual Studio", "a new tab, not a window"): the same admin route with ?window=ide, which the shell
// renders without sidebar, top bar or banners. The code preview tab uses the same bare mode. The tab
// keeps `opener` (same origin) so "Back to admin" can bring the main admin back to the front.
import { useRouterState } from "@tanstack/react-router";

export const IDE_TAB_NAME = "ady-code-editor";

export const THEME_TAB_NAME = "ady-theme-editor";

export const ideHref = (href: string) => `${href}${href.includes("?") ? "&" : "?"}window=ide`;

/** Opens (or focuses) a named tab in bare mode; false when the browser blocked it. */
export function openIdeTab(href: string, name = IDE_TAB_NAME): boolean {
  const w = window.open(ideHref(href), name);
  if (!w) return false;
  w.focus();
  return true;
}

/** "Back to admin" from an editor tab: bring the admin that opened it forward and close this tab;
 * when there is none (or the browser keeps the tab), go back in place. */
export function leaveIdeTab(fallback: () => void) {
  const main = window.opener as Window | null;
  if (main && !main.closed) {
    main.focus();
    window.close();
  }
  setTimeout(fallback, 150);
}

/** True inside a bare tab (the code editor or its preview). */
export function useIdeWindow(): boolean {
  return useRouterState({
    select: (s) => (s.location.search as { window?: unknown }).window === "ide",
  });
}
